import { Card, Grid, Table, TableBody, TableCell, TableRow } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import HighlightedCode from "examples/HighlightedCode";
import DataTable from "examples/Tables/DataTable";
import React from "react";
import sampleRequests from "static-data/sample-requests";
import sampleResponses from "static-data/sample-responses";
import useCopyToClipboard from "../../../../custom-hooks/useCopyToClipboard";
import MDButton from "components/MDButton";
import { ContentCopy } from "@mui/icons-material";
import { useMaterialUIController } from "context";
import PropTypes from "prop-types";
import HttpClientLoginCsharp from "../code/HTTP_Client_Request_Csharp";
import HttpClientLoginCsharpLight from "../code/HTTP_Client_Request_CsharpLight";
import HttpClientLoginPython from "../code/HTTP_Client_Request_Python";
import HttpClientLoginPythonLight from "../code/HTTP_Client_Request_PythonLight";
import HttpClientGetEventsCsharp from "../code/HTTP_Client_Request_Get_Events_Csharp";
import HttpClientGetEventsCsharpLight from "../code/HTTP_Client_Request_Get_Events_CsharpLight";
import HttpClientGetEventsPython from "../code/HTTP_Client_Request_Get_Events_Python";
import HttpClientGetEventsPythonLight from "../code/HTTP_Client_Request_Get_Events_PythonLight";

const ApiDescription = ({ data, search }) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [, copy] = useCopyToClipboard();

  const filter = () => {
    return data?.filter((childVal) => {
      if (search?.toLowerCase() === "") {
        return childVal;
      }
      const q = search.toLowerCase();
      return (
        childVal?.mainHeading?.toLowerCase()?.includes(q) ||
        childVal?.mainHeadingStatic?.toLowerCase()?.includes(q) ||
        childVal?.mainHeadingDesc?.toLowerCase()?.includes(q) ||
        childVal?.mainHeadingDescTwo?.toLowerCase()?.includes(q) ||
        childVal?.mainHeadingDescThree?.toLowerCase()?.includes(q) ||
        childVal?.mainHeadingDescStatic?.toLowerCase()?.includes(q) ||
        childVal?.mainHeadingDescStaticTwo?.toLowerCase()?.includes(q) ||
        childVal?.endPointDesc?.toLowerCase()?.includes(q)
      );
    });
  };

  const filtered = filter();
  const themeMode = darkMode ? "dark-tbl" : "light-tbl";

  const renderSampleCode = (sampleCodeType) => {
    if (sampleCodeType === "login") {
      return (
        <>
          {darkMode ? <HttpClientLoginCsharp /> : <HttpClientLoginCsharpLight />}
          <MDTypography
            variant="h5"
            fontWeight="regular"
            fontFamily="inherit"
            lineHeight={2}
            mt={3}
          >
            HTTP Client Request Python :
          </MDTypography>
          {darkMode ? <HttpClientLoginPython /> : <HttpClientLoginPythonLight />}
        </>
      );
    }
    if (sampleCodeType === "getEvents") {
      return (
        <>
          {darkMode ? (
            <HttpClientGetEventsCsharp />
          ) : (
            <HttpClientGetEventsCsharpLight />
          )}
          <MDTypography
            variant="h5"
            fontWeight="regular"
            fontFamily="inherit"
            lineHeight={2}
            mt={3}
          >
            HTTP Client Request Python :
          </MDTypography>
          {darkMode ? (
            <HttpClientGetEventsPython />
          ) : (
            <HttpClientGetEventsPythonLight />
          )}
        </>
      );
    }
    return null;
  };

  return (
    <>
      {filtered.length === 0 && (
        <MDTypography
          variant="h3"
          fontWeight="regular"
          fontFamily="inherit"
          textAlign="center"
          lineHeight={2}
          id="no-data-found"
        >
          No Results Found!
        </MDTypography>
      )}
      {filtered.length > 0 &&
        filtered.map((childVal, idx) => {
          return (
            <React.Fragment key={childVal.mainGridIdStatic || childVal.mainGridId || idx}>
              {childVal.mainGridIdStatic && (
                <Grid
                  container
                  xs={12}
                  mt={4}
                  id={childVal.mainGridIdStatic}
                >
                  {childVal.mainHeadingStatic && (
                    <MDTypography
                      variant="h4"
                      fontWeight="bold"
                      fontFamily="inherit"
                      lineHeight={1.5}
                      className="section"
                      width="100%"
                      display="block"
                    >
                      {childVal.mainHeadingStatic}
                    </MDTypography>
                  )}
                  {childVal.mainHeadingDescStatic && (
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                      width="100%"
                      display="block"
                    >
                      {childVal.mainHeadingDescStatic}
                    </MDTypography>
                  )}
                  {childVal.descWithLink && (
                    <MDBox display="flex" alignItems="center" flexWrap="wrap" mt={1}>
                      <MDTypography
                        variant="p"
                        fontSize="14px"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                      >
                        {childVal.descWithLink.desc}
                      </MDTypography>
                      <p className="doc-text" style={{ marginLeft: "10px" }}>
                        {childVal.descWithLink.link}
                        <MDButton
                          variant="text"
                          className="copyiconparent"
                          onClick={() => copy(childVal.descWithLink.link)}
                        >
                          <ContentCopy className="copyicon" />
                        </MDButton>
                      </p>
                    </MDBox>
                  )}
                  {childVal.mainHeadingDescStaticTwo && (
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                      width="100%"
                      display="block"
                    >
                      {childVal.mainHeadingDescStaticTwo}
                    </MDTypography>
                  )}
                  {childVal.staticTables &&
                    childVal.staticTables.map((tbl, ti) => (
                      <Grid
                        key={ti}
                        item
                        xs={12}
                        md={tbl.half ? 8 : 12}
                      >
                        <MDBox mt={3} className="table-doc" width="100%">
                          <Card>
                            <MDBox className={themeMode}>
                              <Table>
                                <MDBox
                                  component="thead"
                                  sx={{ background: "#F6F8FA" }}
                                >
                                  <TableRow>
                                    {tbl.columns.map((col) => (
                                      <TableCell
                                        key={col.accessor}
                                        align={col.align || "left"}
                                        sx={{
                                          width: col.width || "auto",
                                          fontWeight: 700,
                                          color: "#022DEC",
                                          textTransform: "uppercase",
                                          fontSize: "0.75rem",
                                          letterSpacing: "0.5px",
                                        }}
                                      >
                                        {col.Header}
                                      </TableCell>
                                    ))}
                                  </TableRow>
                                </MDBox>
                                <TableBody>
                                  {tbl.rows.map((row, ri) => (
                                    <TableRow key={ri}>
                                      {tbl.columns.map((col) => (
                                        <TableCell
                                          key={col.accessor}
                                          align={col.align || "left"}
                                          sx={{ verticalAlign: "top" }}
                                        >
                                          {row[col.accessor]}
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </MDBox>
                          </Card>
                        </MDBox>
                      </Grid>
                    ))}
                  {childVal.responseSplits &&
                    childVal.responseSplits.map((sp, si) => (
                      <Grid
                        key={si}
                        container
                        item
                        xs={12}
                        spacing={3}
                        mt={si === 0 ? 1 : 2}
                        alignItems="flex-start"
                      >
                        <Grid item xs={12} md={8}>
                          <p
                            className={`staus-code ${sp.statusClass}`}
                            style={{ display: "inline-block", margin: 0 }}
                          >
                            {sp.status}
                          </p>
                          <MDTypography
                            variant="p"
                            fontSize="14px"
                            fontWeight="regular"
                            fontFamily="inherit"
                            lineHeight={2}
                            sx={{ display: "block", mt: 1 }}
                          >
                            {sp.details}
                          </MDTypography>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <MDTypography variant="h6" fontWeight="regular">
                            Response Object
                          </MDTypography>
                          <HighlightedCode code={sp.code} />
                        </Grid>
                      </Grid>
                    ))}
                </Grid>
              )}

              {childVal.mainHeading && (
                <Grid
                  container
                  xs={12}
                  mt={4}
                  id={childVal.mainGridId}
                >
                  <Grid
                    item
                    xs={12}
                    md={8}
                    pr={2}
                    className="section"
                  >
                    <MDTypography
                      variant="h4"
                      fontWeight="bold"
                      fontFamily="inherit"
                      lineHeight={2}
                      className="section"
                    >
                      {childVal.mainHeading}
                    </MDTypography>
                    {childVal.mainHeadingDesc && (
                      <p>
                        <MDTypography
                          variant="p"
                          fontSize="14px"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                        >
                          {childVal.mainHeadingDesc}
                        </MDTypography>
                      </p>
                    )}
                    {childVal.introTable && (
                      <MDBox mt={2} mb={2} className="table-doc">
                        <Card>
                          <MDBox className={themeMode}>
                            <DataTable
                              table={{
                                columns: childVal.introTable.columns,
                                rows: childVal.introTable.rows,
                              }}
                              isSorted={false}
                              entriesPerPage={false}
                              showTotalEntries={false}
                              noEndBorder
                            />
                          </MDBox>
                        </Card>
                      </MDBox>
                    )}
                    {childVal.mainHeadingDescTwo && (
                      <p>
                        <MDTypography
                          variant="p"
                          fontSize="14px"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                        >
                          {childVal.mainHeadingDescTwo}
                        </MDTypography>
                      </p>
                    )}
                    {childVal.mainHeadingDescThree && (
                      <p>
                        <MDTypography
                          variant="p"
                          fontSize="14px"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                        >
                          <b>NOTE: </b>
                          {childVal.mainHeadingDescThree}
                        </MDTypography>
                      </p>
                    )}
                    {childVal.endpointId && (
                      <MDTypography
                        variant="h5"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                        id={childVal.endpointId}
                        className="section"
                      >
                        {childVal.endPointHeading}
                      </MDTypography>
                    )}
                    {childVal.endPointMethod && (
                      <MDTypography
                        variant="h6"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={1}
                        className={
                          childVal.endPointMethod === "GET"
                            ? "post-badge get"
                            : "post-badge"
                        }
                      >
                        {childVal.endPointMethod}
                      </MDTypography>
                    )}
                    {childVal.endPointDesc && (
                      <>
                        <MDTypography
                          variant="h6"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={1}
                          className="link-badge"
                        >
                          {childVal.endPointDesc}
                          <MDButton
                            variant="text"
                            className="copyiconparent"
                            onClick={() => copy(childVal.endPointDesc)}
                          >
                            <ContentCopy className="copyicon" />
                          </MDButton>
                        </MDTypography>
                        <br />
                      </>
                    )}
                    {childVal.requestHeader && (
                      <>
                        <MDTypography
                          variant="h5"
                          fontWeight="regular"
                          fontFamily="inherit"
                          mt={3}
                          lineHeight={2}
                          id={childVal.requestHeaderId}
                          className="section"
                        >
                          {childVal.requestHeader}
                        </MDTypography>
                        <MDBox mt={3} className="table-doc">
                          <Card>
                            <MDBox className={themeMode}>
                              <DataTable
                                table={{
                                  columns: childVal.requestHeaderTable.columns,
                                  rows: childVal.requestHeaderTable.rows,
                                }}
                                isSorted={false}
                                entriesPerPage={false}
                                showTotalEntries={false}
                                noEndBorder
                              />
                            </MDBox>
                          </Card>
                        </MDBox>
                      </>
                    )}
                    {childVal.requestBody && (
                      <MDTypography
                        variant="h5"
                        fontWeight="regular"
                        fontFamily="inherit"
                        mt={3}
                        lineHeight={2}
                        id={childVal.requestBodyId}
                        className="section"
                      >
                        {childVal.requestBody}
                      </MDTypography>
                    )}
                    {childVal.requestBodyTable && (
                      <MDBox
                        mt={3}
                        className="table-doc"
                        id={childVal.requestBodyTableId}
                      >
                        <Card>
                          <MDBox className={themeMode}>
                            <DataTable
                              table={{
                                columns: childVal.requestBodyTable.columns,
                                rows: childVal.requestBodyTable.rows,
                              }}
                              isSorted={false}
                              entriesPerPage={false}
                              showTotalEntries={false}
                              noEndBorder
                            />
                          </MDBox>
                        </Card>
                      </MDBox>
                    )}
                    {childVal.requestBodyNote && (
                      <p style={{ marginTop: "15px" }}>
                        <MDTypography
                          variant="p"
                          fontSize="14px"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                        >
                          {childVal.requestBodyNote}
                        </MDTypography>
                      </p>
                    )}
                    {childVal?.SampleCode && (
                      <MDBox mt={3}>
                        <MDTypography
                          variant="h5"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                        >
                          {childVal.SampleCodeTitle}
                        </MDTypography>
                        {renderSampleCode(childVal.sampleCodeType)}
                        {childVal.sampleCodeNote && (
                          <p style={{ marginTop: "15px" }}>
                            <MDTypography
                              variant="p"
                              fontSize="14px"
                              fontWeight="regular"
                              fontFamily="inherit"
                              lineHeight={2}
                            >
                              <b>Note: </b>
                              {childVal.sampleCodeNote}
                            </MDTypography>
                          </p>
                        )}
                      </MDBox>
                    )}
                    {childVal.responseId && (
                      <div id={childVal.responseId} />
                    )}
                  </Grid>

                  {(childVal.reqObjKey || childVal.respObjKey) && (
                    <Grid item xs={12} md={4}>
                      {childVal.reqObjKey && sampleRequests.vflux?.[childVal.reqObjKey] && (
                        <>
                          <MDTypography variant="h6" fontWeight="regular">
                            Request Body
                          </MDTypography>
                          <HighlightedCode
                            code={sampleRequests.vflux[childVal.reqObjKey].trim()}
                          />
                        </>
                      )}
                      {childVal.respObjKey && sampleResponses.vflux?.[childVal.respObjKey] && (
                        <>
                          <MDTypography variant="h6" fontWeight="regular" mt={childVal.reqObjKey ? 3 : 0}>
                            Response Object
                          </MDTypography>
                          <HighlightedCode
                            code={sampleResponses.vflux[childVal.respObjKey].trim()}
                          />
                        </>
                      )}
                    </Grid>
                  )}
                </Grid>
              )}
            </React.Fragment>
          );
        })}
    </>
  );
};
ApiDescription.propTypes = {
  data: PropTypes.array.isRequired,
  search: PropTypes.string.isRequired,
};
export default ApiDescription;
